<template>
	<div class="tabContainer px-3">
		<div class="d-flex">
			<v-text-field
				v-model="search"
				class="py-0 mr-2"
				append-icon="mdi-magnify"
				label="Search"
				single-line
				hide-details
			/>
			<v-btn @click.stop="addField" color="primary">
				<v-icon> mdi-plus</v-icon>
				Add Field
			</v-btn>
		</div>
		<div class="tabInnerContainer" style="overflow-y: scroll">
			<v-data-table
				dense
				hide-default-footer
				disable-pagination
				fixed-header
				loading-text="Loading..."
				:items="reportFields"
				:headers="headers"
				:search.sync="search"
				sort-by="Order"
			>
				<template v-slot:body="props">
					<draggable
						@change="reorder(props.items)"
						:list="props.items"
						tag="tbody"
					>
						<tr v-for="(item, index) in props.items" :key="index">
							<td>
								<v-icon small color="primary"
									>mdi-reorder-horizontal</v-icon
								>
							</td>

							<td>{{ getReportFieldSchema(item) }}</td>
							<td>{{ getReportFieldName(item) }}</td>
							<td>{{ item.Label }}</td>
							<td>
								<v-btn
									fab
									small
									icon
									elevation="1"
									class="action-btn float-right"
									@click.stop="deleteField(item)"
								>
									<v-icon color="error" small
										>mdi-delete</v-icon
									>
								</v-btn>
								<v-btn
									fab
									small
									icon
									elevation="1"
									class="action-btn float-right"
									@click.stop="editField(item)"
								>
									<v-icon color="primary" small
										>mdi-pencil</v-icon
									>
								</v-btn>
							</td>
						</tr>
					</draggable>
				</template>
			</v-data-table>
		</div>
		<v-container fluid class="mt-2">
			<v-row no-gutters>
				<v-spacer />
				<v-btn text outlined @click="onCancel">Cancel</v-btn>
			</v-row>
		</v-container>

		<report-field-modal
			v-if="showReportFieldModal"
			:showDialog="showReportFieldModal"
			:reportField="selectedReportField"
			:index="index"
			@close="onReportFieldModalClose"
		/>
	</div>
</template>
<script>
import ReportFieldModal from './ReportFieldModal.vue';
import ConfirmDialog from '@/components/core/dialogs/confirmDialog';
import Draggable from 'vuedraggable';

import { ReportDetailsActions } from '../../../../../store/actions';
import { ReportDetailsGetters } from '../../../../../store/getters';
import { mapGetters } from 'vuex';
import { reportTypes } from '../../../../../enums/reportTypes';
export default {
	components: { ReportFieldModal, Draggable },
	name: 'ReportFields',
	computed: {
		...mapGetters({
			reportFields: [ReportDetailsGetters.REPORT_FIELDS],
			report: [ReportDetailsGetters.REPORT],
			reportGridViewFields: [ReportDetailsGetters.REPORT_GRIDVIEW_FIELDS],
			schemas: [ReportDetailsGetters.REPORT_FIELDS_SCHEMAS],
		}),
		reorderData() {
			let x = this.reportFields;
			return JSON.parse(
				JSON.stringify(x.sort((a, b) => a.Order - b.Order))
			);
		},
	},
	data() {
		return {
			index: 0,
			reordered: [],
			showReorderFieldModal: false,
			showReportFieldModal: false,
			selectedReportField: null,
			search: null,
			headers: [
				{ text: '', sortable: false, value: 'Draggable', width: 10 },
				{ text: 'Schema', value: 'Schema', sortable: false },
				{ text: 'Field', value: 'Field', sortable: false },
				{ text: 'Label', value: 'Label', sortable: false },
				{ text: '', value: 'actions', sortable: false, align: 'end' },
			],
		};
	},
	methods: {
		reorder(props) {
			this.reordered = props;
			this.reordered.forEach((element) => {
				element.Order = this.reordered.indexOf(element) + 1;
			});

			this.$store.dispatch(ReportDetailsActions.REORDER_REPORT_FIELD, {
				id: this.report.Id,
				data: this.reordered,
			});
		},
		onCancel() {
			this.$router.push({ name: 'ReportBuilder' });
		},
		onReportFieldModalClose() {
			this.showReportFieldModal = false;
			this.selectedReportField = null;
			this.index = 0;
		},
		addField() {
			this.index = this.reportFields.length;
			this.showReportFieldModal = true;
		},
		editField(field) {
			this.selectedReportField = field;
			this.showReportFieldModal = true;
		},
		deleteField(field) {
			ConfirmDialog({
				message: 'Are you sure you want to delete this Report Field?',
			}).then((success) => {
				if (!success) return;
				this.$store.dispatch(
					ReportDetailsActions.DELETE_REPORT_FIELD,
					field
				);
			});
		},
		getReportFieldSchema(field) {
			if (this.report.Type == reportTypes.CUSTOM_DATA)
				return this.report.CustomData;
			if (!this.reportGridViewFields) return null;
			let gvf = this.reportGridViewFields.find(
				(x) => x.Id == field.GridViewFieldId
			);
			if (!gvf) return null;
			if (!this.schemas) return null;
			let schema = this.schemas.find((x) => x.Id == gvf.EntityId);
			if (!schema) return null;
			return schema.Name;
		},
		getReportFieldName(field) {
			if (this.report.Type == reportTypes.CUSTOM_DATA)
				return field.Source;
			if (!this.reportGridViewFields) return null;
			let gvf = this.reportGridViewFields.find(
				(x) => x.Id == field.GridViewFieldId
			);
			if (!gvf) return null;
			return gvf.Label;
		},
	},
};
</script>
<style lang="scss" scoped>
.tabContainer {
	display: flex;
	flex-direction: column;
	overflow: hidden;
	height: 100%;
	.tabInnerContainer {
		flex-grow: 1;
	}
}
</style>
